const triggerCTRLCmdAndClick = (event, cb) => {
    if (event.ctrlKey || event.metaKey) {
      event?.stopPropagation();
      event?.preventDefault();
      cb();
    }
  };
  
  export { triggerCTRLCmdAndClick };